import { localize, readAppLanguage } from '../i18n';
import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import BottomSheet from './BottomSheet';
import FitButton from './ui/FitButton';
import { draftSummary } from '../utils/registrationDraft';

export const draftPrimaryButton = { bgcolor: '#ffe566', color: '#5a4a00', boxShadow: 'none', border: 0,
    borderRadius: 3, fontWeight: 800, minHeight: 52, '&:hover': { bgcolor: '#f2d94f', boxShadow: 'none' } };
export const draftSecondaryButton = { bgcolor: '#f1f2f4', color: '#444', boxShadow: 'none', border: 0,
    borderRadius: 3, fontWeight: 700, minHeight: 48, '&:hover': { bgcolor: '#e5e7eb', boxShadow: 'none' } };

export function RegistrationDraftButton({ children, ...props }) {
    return <FitButton {...props}>{readAppLanguage() === 'ko' || typeof children !== 'string' ? children
        : <Typography component="span" sx={{ font: 'inherit', minWidth: 0, whiteSpace: 'normal', overflowWrap: 'anywhere' }}>{children}</Typography>}
    </FitButton>;
}
const Button = RegistrationDraftButton;

export default function RegistrationDraftChoice({ open, draft, onClose, onResume, onReplace, onDiscard, replacing = false, discarding = false, busy = false, error = '' }) {
    const [confirm, setConfirm] = useState(null);
    const mode = replacing ? 'replace' : discarding ? 'discard' : confirm;
    const close = () => { if (busy) return; if (confirm) setConfirm(null); else onClose(); };
    return <BottomSheet open={open} onClose={close} dismissDisabled={busy} ariaLabelledBy="registration-draft-choice-title">
        <Typography id="registration-draft-choice-title" component="h2" sx={{ fontSize: '1.2rem', fontWeight: 800, color: '#1a1a1a', mt: 1 }}>
            {mode === 'replace' ? localize("작성 중인 내용을 지우고 새로 등록할까요?") : mode === 'discard' ? localize("작성 내용을 버릴까요?") : localize("작성 중인 약 등록이 있어요")}
        </Typography>
        <Typography sx={{ color: '#666', mt: 1, mb: 2, lineHeight: 1.6 }}>
            {mode ? localize("이전에 입력한 이름과 설정은 지워져요.") : draftSummary(draft)}
        </Typography>
        {error && <Typography role="alert" sx={{ color: '#b42318', mb: 1 }}>{error}</Typography>}
        <Box sx={{ display: 'grid', gap: 1, pb: 1 }}>
            {mode ? <>
                <Button variant="contained" fullWidth sx={draftPrimaryButton} disabled={busy} onClick={mode === 'replace' ? onReplace : onDiscard}>
                    {busy ? localize("확인 중이에요") : mode === 'replace' ? localize("지우고 새로 등록하기") : localize("버리기")}
                </Button>
                <Button variant="contained" fullWidth sx={draftSecondaryButton} disabled={busy} onClick={close}>{mode === 'replace' ? localize("돌아가기") : localize("계속 보관하기")}</Button>
            </> : <>
                <Button variant="contained" fullWidth sx={draftPrimaryButton} onClick={onResume}>{localize("이어서 등록하기")}</Button>
                <Button variant="contained" fullWidth sx={draftSecondaryButton} onClick={() => setConfirm('replace')}>{localize("새로 등록하기")}</Button>
                <Button fullWidth variant="contained" sx={draftSecondaryButton} onClick={() => setConfirm('discard')}>{localize("작성 내용 버리기")}</Button>
            </>}
        </Box>
    </BottomSheet>;
}
